import request from 'axios';
import { getClientAuthHeader } from '../../client/token';
import MomentTz from 'moment-timezone';

export const signUpUserFormAction = (data) => {
    if (!data['Timezone']) {
        data['Timezone'] = MomentTz.tz.guess();
    }

    return {
        types: ['SIGN_UP_FORM_REQUEST', 'SIGN_UP_FORM_SUCCESS', 'SIGN_UP_FORM_FAILURE'],
        promise: request.post('/api/v1/user/signup', data)
    };
};


export const updateMyAccountUserAction = (data) => {
    return {
        types: ['UPDATE_MY_ACCOUNT_REQUEST', 'UPDATE_MY_ACCOUNT_SUCCESS', 'UPDATE_MY_ACCOUNT_FAILURE'],
        promise: request.post('/api/v1/user/account', data, getClientAuthHeader())
    };
};

export const addEmployeeUserAction = (data) => {
    return {
        types: ['ADD_EMPLOYEE_REQUEST', 'ADD_EMPLOYEE_SUCCESS', 'ADD_EMPLOYEE_FAILURE'],
        promise: request.post('/api/v1/user/employee/new', data, getClientAuthHeader())
    };
};

export const deleteEmployeeUserAction = (data) => {
    return {
        types: ['DELETE_EMPLOYEE_REQUEST', 'DELETE_EMPLOYEE_SUCCESS', 'DELETE_EMPLOYEE_FAILURE'],
        promise: request.post('/api/v1/user/employee/delete', data, getClientAuthHeader())
    };
};

export const impersonateEmployeeUserAction = (data) => {
    return {
        types: ['IMPERSONATE_EMPLOYEE_REQUEST', 'IMPERSONATE_EMPLOYEE_SUCCESS', 'IMPERSONATE_EMPLOYEE_FAILURE'],
        promise: request.post('/api/v1/user/employee/impersonate', data, getClientAuthHeader())
    };
};

export const resetPasswordUserFormAction = (data) => {
    return {
        types: ['RESET_PASSWORD_REQUEST', 'RESET_PASSWORD_SUCCESS', 'RESET_PASSWORD_FAILURE'],
        promise: request.post('/api/v1/user/password/reset', data, getClientAuthHeader())
    };
};

export const forgotPasswordUserFormAction = (data) => {
    return {
        types: ['FORGOT_PASSWORD_REQUEST', 'FORGOT_PASSWORD_SUCCESS', 'FORGOT_PASSWORD_FAILURE'],
        promise: request.post('/api/v1/user/password/forgot', data, getClientAuthHeader())
    };
};

export const logInUserFormAction = (data) => {
    data['Timezone'] = MomentTz.tz.guess();
    return {
        types: ['LOG_IN_FORM_REQUEST', 'LOG_IN_FORM_SUCCESS', 'LOG_IN_FORM_FAILURE'],
        promise: request.post('/api/v1/user/login', data)
    };
};

export const userLogOutAction = () => {
    return {
        type: 'USER_LOG_OUT'
    };
};

// Tells the server the user logged out. Fire-and-forget: it purges temporary
// "try the live app" demo accounts server-side and is a no-op for everyone else.
// Must run before the client token is cleared (it authenticates with it).
export const serverLogOut = () => {
    return request.post('/api/v1/user/logout', {}, getClientAuthHeader()).catch(() => {});
};

export const userLogInLoadAction = () => {
    return {
        types: ['USER_LOG_IN_LOAD_REQUEST', 'USER_LOG_IN_LOAD_SUCCESS', 'USER_LOG_IN_LOAD_FAILURE'],
        promise: request.get('/api/v1/user/current', getClientAuthHeader())
    };
};

export function userNotificationsAction(caseId) {
    return {
        types: ['USER_NOTIFICATIONS_REQUEST', 'USER_NOTIFICATIONS_SUCCESS', 'USER_NOTIFICATIONS_FAILURE'],
        poll: `/api/v1/user/notifications/`
    };
}

export function userDismissFaxNotification(caseId) {
    return {
        types: ['USER_DISMISS_FAX_NOTIFICATION_REQUEST', 'USER_DISMISS_FAX_NOTIFICATION_SUCCESS', 'USER_DISMISS_FAX_NOTIFICATION_FAILURE'],
        promise: request.delete(' /api/v1/user/notifications/fax/' + encodeURIComponent(caseId), getClientAuthHeader())
    };
}

export const userConfigUpsertAction = (value, key, field) => {
    let data = {
        type: 'single_array_element',
        value,
        key,
        field
    };

    return {
        types: ['CONFIG_UPSERT_REQUEST', 'CONFIG_UPSERT_SUCCESS', 'CONFIG_UPSERT_FAILURE'],
        promise: request.put(`/api/v1/user/config`, data, getClientAuthHeader())
    };
};

export const userConfigDeleteAction = (key, field) => {
    let data = {
        type: 'single_array_element',
        key,
        field
    };

    return {
        types: ['CONFIG_DELETE_REQUEST', 'CONFIG_DELETE_SUCCESS', 'CONFIG_DELETE_FAILURE'],
        promise: request.post(`/api/v1/user/config/delete`, data, getClientAuthHeader())
    };
};

export const userWorkflowUpdateAction = (workflow) => {
    let data = {
        type: 'workflow',
        workflow
    };

    return {
        types: ['CONFIG_UPSERT_REQUEST', 'CONFIG_UPSERT_SUCCESS', 'CONFIG_UPSERT_FAILURE'],
        promise: request.put(`/api/v1/user/config`, data, getClientAuthHeader())
    };
};

export const userClientUpdateAction = (client) => {
    let data = {
        type: 'client',
        client
    };

    return {
        types: ['CONFIG_UPSERT_REQUEST', 'CONFIG_UPSERT_SUCCESS', 'CONFIG_UPSERT_FAILURE'],
        promise: request.put(`/api/v1/user/config`, data, getClientAuthHeader())
    };
};

export const userEmailIntegratedSendAction = (data) => {
    return {
        types: ['USER_EMAIL_INTEGRATED_SEND_REQUEST', 'USER_EMAIL_INTEGRATED_SEND_SUCCESS', 'USER_EMAIL_INTEGRATED_SEND_FAILURE'],
        promise: request.post('/api/v1/user/email/send', data, getClientAuthHeader())
    };
};

export const userEmailIntegratedAction = (integrated, tokenName) => {
    return {
        type: 'USER_EMAIL_INTEGRATED',
        integrated,
        tokenName
    };
};

export const userEmailIntegrationDeleteAction = () => {
    return {
        types: ['USER_EMAIL_INTEGRATION_DELETE_REQUEST', 'USER_EMAIL_INTEGRATION_DELETE_SUCCESS', 'USER_EMAIL_INTEGRATION_DELETE_FAILURE'],
        promise: request.delete(`/api/v1/user/email/token`, getClientAuthHeader())
    };
};

// Turns the "Read email conversations" profile switch on / off. Turning it on may answer with an
// AUTHORIZATION url where the user grants the read permission to the email account.
export const userThemeAction = theme => ({
    types: ['USER_THEME_REQUEST', 'USER_THEME_SUCCESS', 'USER_THEME_FAILURE', theme],
    promise: request.post('/api/v1/user/theme', { theme }, getClientAuthHeader()),
});

export const userEmailReadAction = (enabled) => {
    return request.post(`/api/v1/user/email/read`, {enabled}, getClientAuthHeader());
};

export const userDriveIntegrateAuthAction = (tokenName) => {
    return {
        types: ['USER_DRIVE_INTEGRATED_AUTH_REQUEST', 'USER_DRIVE_INTEGRATED_AUTH_SUCCESS', 'USER_DRIVE_INTEGRATED_AUTH_FAILURE'],
        promise: request.post(`/api/v1/user/drive/auth`, {tokenName}, getClientAuthHeader())
    };
};

export const userDriveIntegratedAction = (integrated, tokenName) => {
    return {
        type: 'USER_DRIVE_INTEGRATED',
        integrated,
        tokenName
    };
};

export const userDriveIntegrationDeleteAction = () => {
    return {
        types: ['USER_DRIVE_INTEGRATION_DELETE_REQUEST', 'USER_DRIVE_INTEGRATION_DELETE_SUCCESS', 'USER_DRIVE_INTEGRATION_DELETE_FAILURE'],
        promise: request.delete(`/api/v1/user/drive/token`, getClientAuthHeader())
    };
};


export const userCalendarListAction = () => {
    return {
        types: ['USER_CALENDAR_LIST_REQUEST', 'USER_CALENDAR_LIST_SUCCESS', 'USER_CALENDAR_LIST_FAILURE'],
        promise: request.get(`/api/v1/user/calendar/list`, getClientAuthHeader())
    };
};


export const userCalendarDefaultAction = (calendarId) => {
    return {
        types: ['USER_CALENDAR_DEFAULT_REQUEST', 'USER_CALENDAR_DEFAULT_SUCCESS', 'USER_CALENDAR_DEFAULT_FAILURE'],
        promise: request.post(`/api/v1/user/calendar/default`, {calendarId}, getClientAuthHeader())
    };
};


export const userDriveListAction = (type) => {
    return {
        types: ['USER_DRIVE_LIST_REQUEST', 'USER_DRIVE_LIST_SUCCESS', 'USER_DRIVE_LIST_FAILURE'],
        promise: request.get(`/api/v1/user/${type}/list`, getClientAuthHeader())
    };
};


export const userDriveConfigAction = (data) => {
    return {
        types: ['USER_DRIVE_CONFIG_REQUEST', 'USER_DRIVE_CONFIG_SUCCESS', 'USER_DRIVE_CONFIG_FAILURE'],
        promise: request.post(`/api/v1/user/drive/config`, data, getClientAuthHeader())
    };
};


export const userDownloadFile = (downloadPath) => {
    return {
        type: 'USER_DOWNLOAD_FILE',
        downloadPath
    };
};

export const userSubscriptionValidateCoupon = (coupon) => {
    let data = {
        coupon
    };

    return {
        types: ['USER_COUPON_VALIDATE_REQUEST', 'USER_COUPON_VALIDATE_SUCCESS', 'USER_COUPON_VALIDATE_FAILURE'],
        promise: request.post('/api/v1/user/subscription/coupon', data)
    };
};

export const userBuyFaxCreditAction = (quantity) => {
    let data = {
        quantity
    };

    return {
        types: ['USER_BUY_FAX_CREDIT_REQUEST', 'USER_BUY_FAX_CREDIT_SUCCESS', 'USER_BUY_FAX_CREDIT_FAILURE'],
        promise: request.post('/api/v1/fax/buy', data, getClientAuthHeader())
    };
};

export const userLawPayListAccountsAction = () => {
    return {
        types: ['USER_LAWPAY_LIST_ACCOUNTS_REQUEST', 'USER_LAWPAY_LIST_ACCOUNTS_SUCCESS', 'USER_LAWPAY_LIST_ACCOUNTS_FAILURE'],
        promise: request.get('/api/v1/user/lawpay/accounts', getClientAuthHeader())
    };
};

export const userLawPayAccountSetAction = (account) => {
    return {
        types: ['USER_LAWPAY_ACCOUNT_SET_REQUEST', 'USER_LAWPAY_ACCOUNT_SET_SUCCESS', 'USER_LAWPAY_ACCOUNT_SET_FAILURE'],
        promise: request.put('/api/v1/user/lawpay/account', account, getClientAuthHeader())
    };
};

export const userLawPayDeleteAction = () => {
    return {
        types: ['USER_LAWPAY_CANCEL_REQUEST', 'USER_LAWPAY_CANCEL_SUCCESS', 'USER_LAWPAY_CANCEL_FAILURE'],
        promise: request.delete('/api/v1/user/lawpay/account', getClientAuthHeader())
    };
};

export const userPayPalAccountSetAction = (email) => {
    return {
        types: ['USER_PAYPAL_ACCOUNT_SET_REQUEST', 'USER_PAYPAL_ACCOUNT_SET_SUCCESS', 'USER_PAYPAL_ACCOUNT_SET_FAILURE'],
        promise: request.put('/api/v1/user/paypal/account', {email}, getClientAuthHeader())
    };
};

export const userPayPalDeleteAction = () => {
    return {
        types: ['USER_PAYPAL_CANCEL_REQUEST', 'USER_PAYPAL_CANCEL_SUCCESS', 'USER_PAYPAL_CANCEL_FAILURE'],
        promise: request.delete('/api/v1/user/paypal/account', getClientAuthHeader())
    };
};

export const userFeedbackAction = (feedback, routingInfo) => {
    let data = {
        feedback,
        routingInfo
    };

    return {
        types: ['USER_FEEDBACK_SEND_REQUEST', 'USER_FEEDBACK_SEND_SUCCESS', 'USER_FEEDBACK_SEND_FAILURE'],
        promise: request.post('/api/v1/user/feedback/send', data, getClientAuthHeader())
    };
};

export const userTaskUpdateAction = (tasks) => {
    return {
        types: ['USER_TASK_UPDATE_REQUEST', 'USER_TASK_UPDATE_SUCCESS', 'USER_TASK_UPDATE_FAILURE'],
        promise: request.post('/api/v1/user/task', tasks, getClientAuthHeader())
    };
};

export const userEmailTemplatesUpdateAction = (templates, field) => {
    const data = {
        type: 'email_templates',
        templates,
        field,
    };

    return {
        types: ['USER_EMAIL_TEMPLATES_UPDATE_REQUEST', 'USER_EMAIL_TEMPLATES_UPDATE_SUCCESS', 'USER_EMAIL_TEMPLATES_UPDATE_FAILURE'],
        promise: request.post('/api/v1/user/email_templates', data, getClientAuthHeader())
    };
};


export const userSmsTemplatesUpdateAction = (templates, field) => {
    const data = {
        type: 'sms_templates',
        templates,
        field,
    };

    return {
        types: ['USER_SMS_TEMPLATES_UPDATE_REQUEST', 'USER_SMS_TEMPLATES_UPDATE_SUCCESS', 'USER_SMS_TEMPLATES_UPDATE_FAILURE'],
        promise: request.post('/api/v1/user/sms_templates', data, getClientAuthHeader())
    };
};

export const userSmsRegisterPhone = (prefix) => {
    const data = { prefix };
    return {
        types: ['USER_SMS_REGISTER_PHONE_REQUEST', 'USER_SMS_REGISTER_PHONE_SUCCESS', 'USER_SMS_REGISTER_PHONE_FAILURE'],
        promise: request.post('/api/v1/user/sms/number', data, getClientAuthHeader()),
    };
};

export const userApiKeyRegister = () => {
    return {
        types: ['USER_API_KEY_REGISTER_REQUEST', 'USER_API_KEY_REGISTER_SUCCESS', 'USER_API_KEY_REGISTER_FAILURE'],
        promise: request.post('/api/v1/subscription/auth', undefined, getClientAuthHeader()),
    };
};

export const userEmailSignatureUpdateAction = (emailSignature, isEmailSignatureRawHtml) => {
    let data = {
        type: 'email_signature',
        emailSignature,
        isEmailSignatureRawHtml,
    };

    return {
        types: ['USER_EMAIL_SIGNATURE_UPDATE_REQUEST', 'USER_EMAIL_SIGNATURE_UPDATE_SUCCESS', 'USER_EMAIL_SIGNATURE_UPDATE_FAILURE'],
        promise: request.post('/api/v1/user/email_signature', data, getClientAuthHeader())
    };
};

export const userCaseStatesUpdateAction = (states, type) => {
    let data = {
        type,
        states
    };

    return {
        types: ['USER_CASE_STATES_UPDATE_REQUEST', 'USER_CASE_STATES_UPDATE_SUCCESS', 'USER_CASE_STATES_UPDATE_FAILURE'],
        promise: request.post('/api/v1/user/caseStates', data, getClientAuthHeader())
    };
};

export const userFiltersUpdateAction = (filters, type) => {
    let data = {
        type,
        filters
    };

    return {
        types: ['USER_FILTERS_UPDATE_REQUEST', 'USER_FILTERS_UPDATE_SUCCESS', 'USER_FILTERS_UPDATE_FAILURE'],
        promise: request.post('/api/v1/user/' + type, data, getClientAuthHeader())
    };
};

export const userGetReports = (range) => ({
    types: ['USER_REPORTS_REQUEST', 'USER_REPORTS_SUCCESS', 'USER_REPORTS_FAILURE'],
    promise: request.post('/api/v1/user/reports', range, getClientAuthHeader()),
});

export const userGetConfigAction = (id) => ({
    types: ['USER_COMFIG_GET_REQUEST', 'USER_COMFIG_GET_SUCCESS', 'USER_COMFIG_GET_FAILURE'],
    promise: request.get(`/api/v1/user/config/${id}`, getClientAuthHeader()),
});

export const userTourDone = tour => ({
    types: ['USER_TOUR_DONE_REQUEST', 'USER_TOUR_DONE_SUCCESS', 'USER_TOUR_DONE_FAILURE', tour],
    promise: request.get(`/api/v1/user/tour/${tour}`, getClientAuthHeader()),
});

export const userSmsSend = (to, text, caseId = undefined) => {
    const data = {
        to,
        text,
        caseId,
    };

    return {
        types: ['USER_SMS_SEND_REQUEST', 'USER_SMS_SEND_SUCCESS', 'USER_SMS_SEND_FAILURE'],
        promise: request.post('/api/v1/user/sms/send', data, getClientAuthHeader()),
    };
};

export const userMessageLogAction = (message) => {
    return {
        types: ['USER_MESSAGE_LOG_REQUEST', 'USER_MESSAGE_LOG_SUCCESS', 'USER_MESSAGE_LOG_FAILURE'],
        promise: request.get(`/api/v1/log?msg=${encodeURIComponent(message)}`, getClientAuthHeader())
    };
};